import type { IResultstash, JsonQuery } from "@mne-core/api";
import { QueryController, createHeaders, fetchJsonQuery } from "@mne-core/api";

import type { IAuthenticationMethod } from "../@types";
import AuthenticationURI from "./AuthenticationURIBuilder";

export interface IFetchAuthMethodsOpts extends RequestInit {
  apiUrl: string;
  apikey?: string;
  ctrl?: QueryController;
}

export const createRequest = (opts: IFetchAuthMethodsOpts): Request => {
  const { apiUrl, apikey, ...restOpts } = opts;
  const uri = new AuthenticationURI().setApiUrl(apiUrl).setSegment(`session/authmethods`).build().toString();

  const headers = createHeaders({
    /* If the apikey is something else then undefined its added */
    "ARGUS-API-KEY": apikey,
    Accept: "application/json",
    "Content-Type": "application/json",
  });

  let localRequestOpts: RequestInit = {
    headers,
    method: "GET",
    mode: "cors",
  };

  if (!apikey) {
    /**
     * Only add cookies if no apikey is provided
     */
    localRequestOpts = {
      ...localRequestOpts,
      credentials: "include",
    };
  }
  return new Request(String(uri), {
    ...localRequestOpts,
    ...restOpts,
  });
};

export async function fetchAuthMethods(
  opts: IFetchAuthMethodsOpts,
): Promise<JsonQuery<IResultstash<IAuthenticationMethod[]>>> {
  return await fetchJsonQuery<IResultstash<IAuthenticationMethod[]>>(createRequest(opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}
